export function getAuthState({ token, userId }) {
  return Boolean(token && userId);
}

export function shouldBypassProtectedRoute(pathname = "") {
  return pathname === "/resetpassword/";
}

export function getRedirectLocation({ pathname = "", search = "" }) {
  return `${pathname}${search}`;
}

export function getLegacyBoardRedirectPath({ boardKey, cardId }) {
  if (!boardKey) {
    return null;
  }

  return cardId
    ? `/board/${boardKey}/${boardKey}-${cardId}`
    : `/board/${boardKey}`;
}

export function wrapRouteElement(element, wrappers = []) {
  return wrappers.reduceRight((currentElement, Wrapper) => {
    if (!Wrapper) {
      return currentElement;
    }

    return <Wrapper>{currentElement}</Wrapper>;
  }, element);
}

export function createRoute({ element, wrappers = [], ...route }) {
  return {
    ...route,
    element: wrapRouteElement(element, wrappers),
  };
}
